export default __webpack_public_path__ + "static/anoj-585a21ce32824f624ab1c01009de0238.svg";